import type {LinkField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {LinkResolverFn} from 'prismicio'
import {ButtonV2} from 'src/common/ButtonV2'
import {Icon} from 'src/common/Icon'

const stresstimonialsDrawerCtaButton = 'stresstimonials-drawer-cta-button'

type CTASectionProps = {
  cta_eyebrow?: string | null
  cta_title?: string | null
  cta_description?: string | null
  primaryButtonData?: {
    link: LinkField
    marketing_id?: string | null
    intent?: string | null
    label?: string | null
  } | null
  linkResolver: LinkResolverFn
  componentIndex: number
  pageUid: string
  componentName: string
}

export const CTASection = ({
  cta_eyebrow,
  cta_title,
  cta_description,
  primaryButtonData,
  linkResolver,
  componentIndex,
  pageUid,
  componentName,
}: CTASectionProps) => {
  if (!primaryButtonData) {
    return null
  }

  const hasTextContent =
    isFilled.keyText(cta_eyebrow) || isFilled.keyText(cta_title) || isFilled.keyText(cta_description)

  const buttonElement = (
    <ButtonV2
      variant="primary"
      href={linkResolver(primaryButtonData.link, stresstimonialsDrawerCtaButton)}
      trackingData={{
        mktgId: primaryButtonData.marketing_id || '',
        location: `component-${componentIndex}-${componentName}`,
        dataType: primaryButtonData.intent || stresstimonialsDrawerCtaButton,
        pageName: pageUid,
        label: primaryButtonData.label || '',
      }}
      newTrackingProps={{
        interaction: {
          element: `stresstimonials-drawer-cta-button`,
          elementText: primaryButtonData.label || '',
          location: `stresstimonials-drawer`,
        },
        pageType: 'stresstimonials',
      }}
      id={`component-${componentIndex}-${componentName}-cta`}
      className="w-fit"
    >
      {hasTextContent ? (
        primaryButtonData.label
      ) : (
        <div className="flex w-full items-center justify-between gap-4">
          <span className="whitespace-nowrap">{primaryButtonData.label}</span>
          <div className="flex shrink-0 items-center justify-center rounded-[1.4px] bg-moss-white p-[6px]">
            <Icon name="arrow" className="size-2.5 text-moss-black" />
          </div>
        </div>
      )}
    </ButtonV2>
  )

  if (!hasTextContent) {
    return buttonElement
  }

  return (
    <div className="flex w-full flex-col gap-6 rounded-lg border border-moss-grey-150 bg-moss-white p-[22px]">
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2">
          {isFilled.keyText(cta_eyebrow) && (
            <p className="text-[11px] font-semibold uppercase tracking-[0.66px] text-grey-300">{cta_eyebrow}</p>
          )}
          {isFilled.keyText(cta_title) && (
            <h3 className="text-[24px] font-medium leading-normal text-moss-black">{cta_title}</h3>
          )}
        </div>
        {isFilled.keyText(cta_description) && (
          <p className="text-[20px] font-normal leading-[1.35] text-moss-grey-400">{cta_description}</p>
        )}
      </div>
      {buttonElement}
    </div>
  )
}
